import api from "pages/api/axiosInstance";
import useSWR from "swr";

export type MaxCompletedDayResponse = {
  isSuccess: boolean;
  code: number;
  message: string;
  result: string;
};

/**
 * 학생 최대 학습 완료 일수를 조회한다.
 * `GET /app/learning/max-completed-day`
 *
 * @returns SWR 결과. `data`는 `string`(최대 학습 완료 날짜).
 */
export const useGetMaxCompletedDay = () => {
  return useSWR("/app/learning/max-completed-day", () =>
    api
      .get<MaxCompletedDayResponse>("/app/learning/max-completed-day")
      .then((res) => {
        return res.data.result;
      })
  );
};
